import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // Get the redirect parameter from route data
    const redirectPath = route.data['redirectPath'] || '';
    if (!this.authService.isLoggedIn()) {
      this.router.navigate([redirectPath]);
      return false;
    }
    return true;
  }
}
